(function () {
  if (window.__geekCraftsEventsLoaded) return;
  window.__geekCraftsEventsLoaded = true;

  function parseDate(str) {
    if (!str) return null;
    return new Date(str + 'T00:00:00');
  }

  function startOfToday() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function formatDatePt(date) {
    if (!date) return '';
    return date.toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit' });
  }

  function formatDateRangePt(startStr, endStr) {
    var start = parseDate(startStr);
    if (endStr && endStr !== startStr) {
      var end = parseDate(endStr);
      return formatDatePt(start) + ' a ' + formatDatePt(end);
    }
    return formatDatePt(start);
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function toIcsDate(date) {
    return date.getFullYear() + pad(date.getMonth() + 1) + pad(date.getDate());
  }

  function nextDay(date) {
    var d = new Date(date);
    d.setDate(d.getDate() + 1);
    return d;
  }

  function buildGoogleLink(card) {
    var start = parseDate(card.dataset.start);
    var end = nextDay(parseDate(card.dataset.end || card.dataset.start));
    var params = new URLSearchParams({
      action: 'TEMPLATE',
      text: card.dataset.name || '',
      dates: toIcsDate(start) + '/' + toIcsDate(end),
      location: card.dataset.location || '',
      details: card.dataset.description || ''
    });
    return 'https://calendar.google.com/calendar/render?' + params.toString();
  }

  function downloadIcs(card) {
    var start = parseDate(card.dataset.start);
    var end = nextDay(parseDate(card.dataset.end || card.dataset.start));
    var slug = (card.dataset.name || 'evento').toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var lines = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//GeekCrafts by LS//Eventos//PT',
      'BEGIN:VEVENT',
      'UID:' + slug + '-' + toIcsDate(start) + '@geekcrafts.pt',
      'DTSTAMP:' + toIcsDate(new Date()) + 'T000000Z',
      'DTSTART;VALUE=DATE:' + toIcsDate(start),
      'DTEND;VALUE=DATE:' + toIcsDate(end),
      'SUMMARY:' + (card.dataset.name || ''),
      'LOCATION:' + (card.dataset.location || ''),
      'DESCRIPTION:' + (card.dataset.description || ''),
      'END:VEVENT',
      'END:VCALENDAR'
    ];
    var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = slug + '.ics';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  function getEventCards(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-event-card]'));
  }

  function isUpcoming(card, today) {
    var end = parseDate(card.dataset.end || card.dataset.start);
    return end >= today;
  }

  function sortByStart(cards) {
    return cards.sort(function (a, b) {
      return parseDate(a.dataset.start) - parseDate(b.dataset.start);
    });
  }

  function wireAddToCalendar(root) {
    getEventCards(root).forEach(function (card) {
      var btn = card.querySelector('[data-add-to-calendar]');
      var menu = card.querySelector('[data-add-menu]');
      if (!btn || !menu) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasHidden = menu.hidden;
        document.querySelectorAll('[data-add-menu]').forEach(function (m) {
          m.hidden = true;
        });
        menu.hidden = !wasHidden;
      });
      var googleBtn = card.querySelector('[data-add-google]');
      var icsBtn = card.querySelector('[data-add-ics]');
      if (googleBtn) {
        googleBtn.addEventListener('click', function () {
          window.open(buildGoogleLink(card), '_blank', 'noopener');
          menu.hidden = true;
        });
      }
      if (icsBtn) {
        icsBtn.addEventListener('click', function () {
          downloadIcs(card);
          menu.hidden = true;
        });
      }
    });
  }

  document.addEventListener('click', function () {
    document.querySelectorAll('[data-add-menu]').forEach(function (m) {
      m.hidden = true;
    });
  });

  function initGrids() {
    document.querySelectorAll('[data-events-grid]').forEach(function (grid) {
      var today = startOfToday();
      var cards = sortByStart(getEventCards(grid).filter(function (c) {
        return isUpcoming(c, today);
      }));
      var maxVisible = parseInt(grid.dataset.maxVisible || '6', 10);

      getEventCards(grid).forEach(function (c) {
        c.hidden = true;
      });

      cards.slice(0, maxVisible).forEach(function (c) {
        c.hidden = false;
        var dateEl = c.querySelector('[data-card-date]');
        if (dateEl) dateEl.textContent = formatDateRangePt(c.dataset.start, c.dataset.end);
        grid.appendChild(c);
      });

      var section = grid.closest('.events-list-section');
      var emptyEl = section ? section.querySelector('[data-events-empty]') : null;
      if (emptyEl) emptyEl.hidden = cards.length > 0;

      wireAddToCalendar(grid);
    });
  }

  function initBanner() {
    var banner = document.querySelector('[data-events-banner]');
    if (!banner) return;

    var today = startOfToday();
    var weekAhead = new Date(today);
    weekAhead.setDate(weekAhead.getDate() + 7);

    var qualifying = sortByStart(getEventCards(banner).filter(function (c) {
      var start = parseDate(c.dataset.start);
      var end = parseDate(c.dataset.end || c.dataset.start);
      return end >= today && start <= weekAhead;
    }));

    if (qualifying.length === 0) return;

    var textEl = banner.querySelector('[data-banner-text]');
    var names = qualifying.map(function (c) {
      return c.dataset.name + ' (' + formatDateRangePt(c.dataset.start, c.dataset.end) + ')';
    });
    var intro = qualifying.length > 1
      ? 'Esta semana estamos em ' + qualifying.length + ' eventos: '
      : 'Esta semana estamos em: ';
    if (textEl) textEl.textContent = intro + names.join(' e ');

    banner.hidden = false;

    var dismissBtn = banner.querySelector('[data-banner-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        banner.hidden = true;
      });
    }
  }

  function initTimeline() {
    var root = document.querySelector('[data-timeline-root]');
    if (!root) return;

    var section = root.closest('.events-timeline-section');
    var source = section ? section.querySelector('[data-timeline-source]') : null;
    if (!source) return;
    var emptyEl = section ? section.querySelector('[data-timeline-empty]') : null;
    var today = startOfToday();

    var allCards = Array.prototype.slice.call(source.querySelectorAll('[data-timeline-card]'));
    var pastCards = allCards.filter(function (c) {
      var end = parseDate(c.dataset.end || c.dataset.start);
      return end < today;
    });

    root.innerHTML = '';

    if (pastCards.length === 0) {
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    var byYear = {};
    pastCards.forEach(function (c) {
      var year = parseDate(c.dataset.start).getFullYear();
      if (!byYear[year]) byYear[year] = [];
      byYear[year].push(c);
    });

    var years = Object.keys(byYear).map(Number).sort(function (a, b) {
      return b - a;
    });

    var slotWidth = 100;
    var startX = 100;
    var cardWidth = 160;
    var dotRadius = 7;
    var connectorLen = 16;
    var topPad = 10;

    function buildCard(c) {
      var card = document.createElement('a');
      card.className = 'events-timeline-section__card';
      card.href = c.dataset.blog || 'javascript:void(0)';
      if (c.dataset.blog) {
        card.target = '_blank';
        card.rel = 'noopener';
      }

      if (c.dataset.image) {
        var media = document.createElement('span');
        media.className = 'events-timeline-section__card-media';
        var img = document.createElement('img');
        img.src = c.dataset.image;
        img.alt = c.dataset.name || '';
        img.loading = 'lazy';
        media.appendChild(img);
        card.appendChild(media);
      }

      var dateP = document.createElement('p');
      dateP.className = 'events-timeline-section__card-date';
      dateP.textContent = formatDatePt(parseDate(c.dataset.start));
      var nameP = document.createElement('p');
      nameP.className = 'events-timeline-section__card-name';
      nameP.textContent = c.dataset.name || '';

      card.appendChild(dateP);
      card.appendChild(nameP);
      return card;
    }

    years.forEach(function (year) {
      var yearCards = byYear[year].sort(function (a, b) {
        return parseDate(a.dataset.start) - parseDate(b.dataset.start);
      });

      var scroller = document.createElement('div');
      scroller.className = 'events-timeline-section__scroller';

      var track = document.createElement('div');
      track.className = 'events-timeline-section__track';
      var trackWidth = Math.max(400, startX + yearCards.length * slotWidth + 100);
      track.style.minWidth = trackWidth + 'px';
      scroller.appendChild(track);
      root.appendChild(scroller);

      var badgeAnchor = document.createElement('div');
      badgeAnchor.className = 'events-timeline-section__badge-anchor';
      var badge = document.createElement('span');
      badge.className = 'events-timeline-section__year-badge';
      badge.textContent = year;
      badgeAnchor.appendChild(badge);
      track.appendChild(badgeAnchor);

      var line = document.createElement('div');
      line.className = 'events-timeline-section__line';
      line.style.left = '70px';
      track.appendChild(line);

      // Pass 1: build every card and measure its natural height
      // (positioned off-canvas so nothing is visible before final layout).
      var cardEls = yearCards.map(function (c) {
        var card = buildCard(c);
        card.style.top = '-9999px';
        track.appendChild(card);
        return card;
      });
      var heights = cardEls.map(function (el) {
        return el.offsetHeight;
      });
      var maxCardHeight = Math.max.apply(null, heights.concat([60]));

      // Pass 2: derive line position + row height from the tallest card,
      // then place every dot/connector/card so the connector always
      // touches the card edge, whatever that card's own height is.
      var lineY = topPad + maxCardHeight + connectorLen + dotRadius;
      var rowHeight = lineY * 2;
      track.style.height = rowHeight + 'px';
      badgeAnchor.style.height = rowHeight + 'px';
      badge.style.top = lineY + 'px';
      line.style.top = lineY + 'px';

      yearCards.forEach(function (c, i) {
        var x = startX + i * slotWidth;
        var above = i % 2 === 0;
        var card = cardEls[i];
        var cardH = heights[i];

        var dot = document.createElement('div');
        dot.className = 'events-timeline-section__dot';
        dot.style.left = x + 'px';
        dot.style.top = (lineY - dotRadius) + 'px';
        track.appendChild(dot);

        var connector = document.createElement('div');
        connector.className = 'events-timeline-section__connector';
        connector.style.left = (x + dotRadius - 1) + 'px';
        connector.style.height = connectorLen + 'px';

        card.style.left = (x + dotRadius - cardWidth / 2) + 'px';

        if (above) {
          connector.style.top = (lineY - dotRadius - connectorLen) + 'px';
          card.style.top = (lineY - dotRadius - connectorLen - cardH) + 'px';
        } else {
          connector.style.top = (lineY + dotRadius) + 'px';
          card.style.top = (lineY + dotRadius + connectorLen) + 'px';
        }
        track.appendChild(connector);
      });
    });
  }

  function initAll() {
    initGrids();
    initBanner();
    initTimeline();
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', initAll);
})();
